<template>
    <div class="dialog" v-show="showMask">
        <el-dialog :modal-append-to-body='false'
                   :visible.sync="dialogVisible"
                   width="30%">
            <ul class="nav_title_ul" style="margin-top: -40px">
                <li class="nav_title_li"
                    :class="nav_title==='购买' ? 'active_nav' : ''"
                    @click="tab_nav('购买')"
                >
                    购买
                </li>
                <li class="nav_title_li"
                    :class="nav_title==='充值' ? 'active_nav' : ''"
                    @click="tab_nav('充值')"
                >
                    充值
                </li>
            </ul>
            <div class="stuff_div">
                <keep-alive>
                    <component :is="stuff_component_dict[nav_title]" :data="data"
                               :no_reload="{'no_reload': true}"
                               @message_back="message_back"
                               :user_item_id="user_document_id" :type="'ir.attachment'"
                               :all_need_count="data.price * 100" :recharge_amount="data.price"></component>
                </keep-alive>
            </div>
        </el-dialog>
        <div class="dialog-container" v-if="data">
            <div class="bar-navigate">
                <div class="dialog-icon">
                    <div class="o_image o_image_thumbnail" :data-mimetype="data.mimetype"/>
                </div>
                <div class="dialog-title">
                    <span class="text_title">{{data.name}}</span>
                </div>
            </div>
            <div class="doc-info">
                <div class="doc-main">
                    <img :src="data.picture_url"/>
                </div>
                <div class="doc-side">
                    <!--<span>简介</span>-->
                    <!--<span class="margin-right-10">{{data.description}}</span>-->
                    <span class="margin-right-10" style="color: red"><span v-if="data.price_name">{{data.price_name}}</span><span v-else>价格</span> ￥{{data.price}}</span>
                    <span class="margin-right-10">共{{data.page_count}}页</span>
                    <span class="margin-right-10">
                        {{data.tags.map(x => x.name).join(',')}}
                    <span v-for="tag in data.tags" :key="tag.id" class="m-1 badge-tag">
                                        {{tag.name}}
                                    </span>
                    </span>
                    <span class="margin-right-10">下载：99</span>
                </div>
                <div class="doc-comment">
                    <div style="font-weight: bold;">
                        <span style="float: left;margin-right: 10px">您的评价</span>
                        <span style="float: left"><el-rate v-model="comment_rate"></el-rate></span>
                    </div>
                    <div style="clear: both"></div>
                    <div class="comment_dialog">
                        <div class="comment_dialog">
                            <!-- 包括登陆状态和未登陆状态 -->
                            <div class="send_comment_div"
                                 v-if="sign_on"
                            >
                <textarea class="comment_text_area" id="comment_text_area"
                          placeholder="请输入您想说的话..."
                          v-model="comment_content">
                </textarea>
                                <div class="comment_operation_div">
                                    <button class="post_comment_button"
                                            @click="_post_comment()"
                                    >发表评论
                                    </button>
                                </div>
                            </div>

                            <div class="unlogin_dialog_div"
                                 v-if="!sign_on"
                            >
                                请
                                <a href="javascript:;"
                                   class="login_button"
                                   @click="show_login"
                                >
                                    登陆
                                </a>
                                后发表评论
                            </div>
                        </div>
                    </div>
                    <div class="user_comments">
                        <div style="font-weight: bold;">
                            <!--{{data.comment_list}}-->
                            <span>用户评价({{data.comment_list.length}})</span>
                        </div>
                        <div style="height:450px;">
                            <el-scrollbar style="height:450px;">
                                <div class="one_comment_div" v-for="comment in data.comment_list"
                                     :key="comment.id">
                                    <div class="qa_item_question_div">
                                        <router-link tag="a"
                                                     :to="{ name: 'user', params: { id: comment.author.id } }">
                                            <img :src="comment.author.avatar_url"
                                                 class="item_question_avatar"/>
                                        </router-link>
                                        <div class="item_question">
                                            <div class="item_question_title">
                                            <span style="float: left">
                                                 <el-rate v-model="comment.rate" disabled>
                                                 </el-rate>
                                            </span>

                                                <span style="float: left;margin-right: 10px">{{comment.author.name}}</span>
                                                <span>
                                                发表于
                                            </span>
                                                <span>{{comment.created_at.substring(0,10)}}</span>
                                            </div>
                                            <!--<a v-else-->
                                            <!--class="item_question_title">-->
                                            <!--{{comment.content.substring(0,10)}}...-->
                                            <!--</a>-->
                                            <div class="item_question_base_info">
                                                <span>{{comment.content}}</span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-scrollbar>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns">
                <div v-if="type == 'download'" class="confirm-btn" @click="downloadBtn">下载</div>
                <div v-if="type != 'confirm'" class="default-btn" @click="closeBtn">关闭</div>
                <div v-if="type == 'confirm'" class="confirm-btn" @click="confirmBtn">确认</div>
            </div>
            <div class="close-btn" @click="closeMask"><i class="fa fa-close"></i></div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import Expense from '@/components/pay_page/expense.vue'
    import Pay from '@/components/pay_page/pay.vue'
    import CommentDialog from '@/components/common_components/comments/comment_dialog.vue'
    import accountApi from '@/api/account/account.js'
    import CommentsApi from '@/api/comments/comments.js'

    import documentApi from '@/api/document/document.js'
    import {mapState, mapActions} from 'vuex'
    import axios from 'axios'

    export default {
        props: {
            value: {},
            data: {
                type: Object,
                require: false
            },
            type: {},
            document_access: {},
        },
        data: function () {
            return {
                showMask: false,
                nav_title: '购买',
                stuff_component_dict: {
                    '购买': 'Expense',
                    '充值': 'Pay'
                },
                dialogVisible: false,
                user_document_id: 0,
                comment_rate: 5,
                comment_content: '',
            }
        },
        components: {
            CommentDialog,
            Expense,
            Pay,
        },

        computed: {
            ...mapState({
                sign_on: state => state.loginState.sign_on,
                user_info: state => state.loginState.user_info
            }),
            // need_count: function () {
            //     let need_count = {
            //         'gold_count': 0,
            //         'silver_count': 0,
            //         'copper_count': 0,
            //     }
            //     let document_all_count = this.data.price * 100
            //     let user_copper_count = this.login_user_coin_count.copper_count
            //     if (user_copper_count <= document_all_count) {
            //         need_count.copper_count = user_copper_count
            //     } else {
            //         need_count.copper_count = document_all_count
            //         return need_count
            //     }
            //     document_all_count -= need_count.copper_count
            //
            //     let user_silver_count = this.login_user_coin_count.silver_count
            //     if (user_silver_count * 10 <= document_all_count) {
            //         need_count.silver_count = user_silver_count
            //     } else {
            //         need_count.silver_count = document_all_count / 10
            //         return need_count
            //     }
            //     document_all_count -= need_count.silver_count * 10
            //
            //     let user_gold_count = this.login_user_coin_count.gold_count
            //     if (user_gold_count * 100 <= document_all_count) {
            //         need_count.gold_count = user_gold_count
            //     } else {
            //         need_count.gold_count = document_all_count / 100
            //         return need_count
            //     }
            //     document_all_count -= need_count.gold_count * 100
            //     return need_count
            //
            //
            // }
        },
        watch: {
            value(newVal) {
                this.showMask = newVal;
            },
            showMask(val) {
                this.$emit('input', val);
            }
        },
        methods: {
            ...mapActions({
                post_comment: 'comments/post_comment',
                change_show_state: 'loginState/change_show_state',
            }),
            message_back: function(){
                console.log('doc dialog buy success')
                this.dialogVisible = false
                this.$emit('buy_success')
            },
            show_login: function () {
                this.change_show_state('on')
                this.closeMask()
            },
            _post_comment: async function () {
                let args = {
                    'content': this.comment_content,
                    'rate': this.comment_rate,
                    'topic_id': this.data.id,
                    'topic_type': 'document'
                }
                let res = await CommentsApi.post_comment(args)
                let data = JSON.parse(res.data.result)
                this.data.comment_list.unshift(data.comment)
                this.comment_rate = 5
                this.comment_content = ''
            },
            tab_nav(nav_title) {
                this.nav_title = nav_title
            },
            closeMask() {
                this.$emit('close');
                // this.showDialog = false;
            },
            downloadBtn() {
                if (this.data) {
                    if (!this.sign_on) {
                        this.change_show_state('on')
                        this.closeMask()
                    } else {
                        if (this.document_access) {
                            axios({method: 'get', url: this.data.html_url, responseType: 'blob'}).then(res => {
                                if (window.navigator.msSaveBlob) {  // IE以及IE内核的浏览器
                                    try {
                                        // res为接口返回数据，这里请求的时候已经处理了，如果没处理需要在此之前自行处理
                                        // var data = new Blob([res.data])
                                        // 注意这里需要是数组形式的,fileName就是下载之后的文件名
                                        window.navigator.msSaveBlob(res, this.data.name)
                                        // window.navigator.msSaveOrOpenBlob(res, fileName);
                                        // 此方法类似上面的方法，区别可自行百度
                                    } catch (e) {
                                        console.log(e)
                                    }
                                } else {
                                    let url = window.URL.createObjectURL(res.data)
                                    let link = document.createElement('a')
                                    link.style.display = 'none'
                                    link.href = url
                                    link.setAttribute('download', this.data.name)// 文件名
                                    document.body.appendChild(link)
                                    link.click()
                                    document.body.removeChild(link) // 下载完成移除元素
                                    window.URL.revokeObjectURL(url) // 释放掉blob对象
                                }
                                this.closeMask();
                            }).catch((e) => {
                                console.log(e);
                            });
                        } else {
                            documentApi.join_document({'id': this.data.id}).then((res) => {
                                let data = JSON.parse(res.data.result)
                                if (data.code == 'success') {
                                    this.user_document_id = data.user_document_id
                                }
                            })
                            this.dialogVisible = true
                        }
                    }


                }
            },
            closeBtn() {
                this.$emit('cancel');
                this.closeMask();
            },
            confirmBtn() {
                this.$emit('confirm');
                this.closeMask();
            },
        },
        mounted() {
            this.showMask = this.value;
        },
    }
</script>
<style>
    .el-scrollbar__wrap {
        overflow-x: hidden;
    }
</style>
<style lang="scss" scoped>
    .one_comment_div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0;
        border-bottom: 1px solid #eee;
    }

    .qa_item_question_div {
        display: flex;
        /*width: 83%;*/
    }

    .item_question {
        display: flex;
        flex-direction: column;
        padding: 0 15px;
        /*max-width: 83%;*/
        /*max-width: 600px;*/
    }

    .item_question_avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        /*margin-top: 20px;*/
    }

    .item_question_title {
        display: inline-block;
        white-space: nowrap;
        /*font-size: 16px;*/
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #4c5157;
        max-width: 100%;
    }

    .item_question_base_info {
        margin-top: 8px;
        font-size: 13px;
        color: #9b9da2;
    }

    .unlogin_dialog_div {
        height: 100px;
        width: 100%;
        margin: 12px 0 30px;
        padding: 6px 12px;
        background: #fafbfa;
        font-size: 14px;
        text-align: center;
        line-height: 86px;
        border: 1px solid #ececec;
    }

    .login_button {
        color: #6CF;
    }

    .login_button:hover {
        color: #6CF;
        text-decoration: underline !important;
    }

    /* */
    .send_comment_div {
        display: flex;
        flex-direction: column;
    }

    .comment_text_area {
        width: 100%;
        font-size: 16px;
        color: #555;
        margin-top: 12px;
        padding: 6px 12px;
        background: #fafbfa;
        border: 1px solid #ececec;
        overflow-y: auto;
        resize: none;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    }

    .comment_text_area:focus {
        outline: 0;
        border: 1px solid #59C0F0;
        box-shadow: 0 0 0 1px #21d6a8;
    }

    .comment_operation_div {
        display: flex;
        justify-content: flex-end;
    }

    .post_comment_button {
        margin: 10px 0;
        padding: .375rem .75rem;
        font-size: 1rem;
        text-align: center;
        vertical-align: center;
        border: 1px solid transparent;
        border-radius: .25rem;
        color: #fff;
        background-color: rgb(8, 191, 145);
        outline: 0;
        align-self: flex-end;
        margin-left: 20px;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .post_comment_button:hover {
        cursor: pointer;
        background: #21d6a8;
        border-color: #21d6a8;
    }

    .cancel_comment_button {
        border: 1px solid transparent;
        border-radius: .25rem;
        padding: .375rem .75rem;
        font-size: 1rem;
        text-align: center;
        margin: 10px 0;
        background-color: transparent;
        border-color: #6c757d;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .cancel_comment_button:hover {
        color: #fff;
        border-color: #6c757d;
        background-color: #6c757d;
    }

    .nav_title_ul {
        display: flex;
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
    }

    .nav_title_li {
        font-size: 16px;
        padding: 3px 5px;
        padding-bottom: 7px;
        margin-right: 25px;
        margin-bottom: -1px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }

    .active_nav {
        border-bottom-color: #66CCFF;;
    }

    .dialog {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 9999;

        .dialog-container {
            width: 90%; //800px;
            height: 90%;
            background: #ffffff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 8px;
            position: relative;

            .bar-navigate {
                width: 100%;
                height: 52px;
                border-bottom: solid 1px lightgray;
            }

            .dialog-icon {
                float: left;
                padding: 10px;
                width: fit-content;

                .o_image {
                    width: 32px;
                    height: 32px;
                }
            }

            .dialog-title {
                width: 80%;
                font-size: 20px;
                color: #696969;
                font-weight: 600;
                padding: 12px 32px 0 54px;
                box-sizing: border-box;
            }

            .doc-info {
                color: #333333;
                padding: 15px;
                box-sizing: border-box;
                height: calc(90% - 60px);

                .doc-subline {

                }

                .doc-main {
                    background-color: #eeeeee;
                    display: inline-block;
                    width: 75%;
                    height: 100%;
                    text-align: center;
                }

                .doc-side {
                    display: inline-block;
                    width: 25%;
                    padding-left: 20px;
                    position: absolute;
                }

                .doc-comment {
                    display: inline-block;
                    width: 25%;
                    margin-top: 50px;
                    padding-left: 20px;
                    position: absolute;
                }
            }

            .inp {
                margin: 10px 0 0 20px;
                width: 200px;
                height: 40px;
                padding-left: 4px;
                border-radius: 4px;
                border: none;
                background: #efefef;
                outline: none;

                &:focus {
                    border: 1px solid #509EE3;
                }
            }

            .btns {
                width: 100%;
                height: 60px;
                // line-height: 60px;
                position: absolute;
                bottom: 0;
                left: 0;
                text-align: right;
                padding: 0 16px;
                box-sizing: border-box;

                & > div {
                    display: inline-block;
                    height: 32px;
                    line-height: 32px;
                    padding: 0 20px;
                    color: #ffffff;
                    background: #f1f1f1;
                    border-radius: 1px;
                    margin-right: 12px;
                    cursor: pointer;
                }

                .default-btn {
                    color: #787878;

                    &:hover {
                        color: #509EE3;
                    }
                }

                .danger-btn {
                    background: #EF8C8C;

                    &:hover {
                        background: rgb(224, 135, 135);
                    }

                    &:active {
                        background: #EF8C8C;
                    }
                }

                .confirm-btn {
                    color: #ffffff;
                    background: #509EE3;

                    &:hover {
                        background: #6FB0EB;
                    }
                }
            }

            .close-btn {
                position: absolute;
                top: 12px;
                right: 12px;
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 18px;
                cursor: pointer;

                &:hover {
                    font-weight: 600;
                }
            }
        }
    }

</style>
